import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo } from 'react';
import { Size } from "./types";
var defaultViewBox = '0 0 24 24';

// новый формат обертки для токенов иконок
export var SvgWrap = function SvgWrap(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '#13171b' : _ref$fill,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? defaultViewBox : _ref$viewBox,
    _ref$ratio = _ref.ratio,
    ratio = _ref$ratio === void 0 ? 1 : _ref$ratio,
    Icon = _ref.iconBody,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Icon, {
    className: className,
    fill: fill,
    height: typeof size === 'number' ? size : Size[size],
    viewBox: viewBox,
    width: typeof size === 'number' ? size * ratio : Size[size],
    "data-t-id": "src-icons"
  });
};
var getRatioFromViewBox = function getRatioFromViewBox(viewBox) {
  var _viewBox$split = viewBox.split(' '),
    _viewBox$split2 = _slicedToArray(_viewBox$split, 4),
    width = _viewBox$split2[2],
    height = _viewBox$split2[3];
  return +width / +height;
};
export var withTokenSvgWrap = function withTokenSvgWrap(iconBody) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$viewBox = _ref2.viewBox,
    viewBox = _ref2$viewBox === void 0 ? defaultViewBox : _ref2$viewBox,
    ratio = _ref2.ratio;
  var targetRatio = ratio || getRatioFromViewBox(viewBox);
  var SvgIcon = function SvgIcon(props) {
    return /*#__PURE__*/React.createElement(SvgWrap, _extends({
      iconBody: iconBody,
      ratio: targetRatio,
      viewBox: viewBox
    }, props));
  };
  return /*#__PURE__*/memo(SvgIcon);
};